import { render, staticRenderFns } from "./courseTop.vue?vue&type=template&id=02994cda"
import script from "./courseTop.vue?vue&type=script&lang=js"
export * from "./courseTop.vue?vue&type=script&lang=js"
import style0 from "./courseTop.vue?vue&type=style&index=0&id=02994cda&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports